import React from 'react'

import { Disclosure } from '@cred/react-disclosures-sdk'

const disclaimers = {
  'sallie-mae': (
    <Disclosure required={false} slug="partners-widgets.student-loans.disclaimer.sallie-mae" />
  ),
  discover: (
    <Disclosure required={false} slug="partners-widgets.student-loans.disclaimer.discover" />
  ),
  'citizens-bank': (
    <Disclosure required={false} slug="partners-widgets.student-loans.disclaimer.citizens-bank" />
  ),
  suntrust: (
    <Disclosure required={false} slug="partners-widgets.student-loans.disclaimer.suntrust" />
  ),
  cas: <Disclosure required={false} slug="partners-widgets.student-loans.disclaimer.cas" />,
  ascent: <Disclosure required={false} slug="partners-widgets.student-loans.disclaimer.ascent" />,
  invested: (
    <Disclosure required={false} slug="partners-widgets.student-loans.disclaimer.invested" />
  ),
  'cog-fin': (
    <Disclosure
      required={false}
      slug="partners-widgets.student-loans.disclaimer.customchoice.cogfin"
    />
  ),
  nelnet: (
    <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.nelnet-bank" />
  ),
  mefa: <Disclosure required={false} slug="partners-widgets.student-loans.disclaimer.mefa.psl" />,
  edvestinu: (
    <Disclosure required={false} slug="partners-widgets.student-loans.disclaimer.edvestinu.psl" />
  ),
  elfi: <Disclosure required={false} slug="partners-widgets.inschool.disclaimer.elfi" />,
  sofi: <Disclosure required={false} slug="partners-widgets.student-loan-refi.disclaimer.sofi" />,
  abe: <Disclosure required={false} slug="partners-widgets.student-loans.disclaimer.abe" />,
}

export default disclaimers
